export const VALIDATE_ACCESS_CODE_REQUEST =
  '@access-code/validate-access-code-request';
export const VALIDATE_ACCESS_CODE_SUCCESS =
  '@access-code/validate-access-code-success';
export const VALIDATE_ACCESS_CODE_FAILURE =
  '@access-code/validate-access-code-failure';
